export const tokenCookieName = 'token'